<template>
	<div
		class="row d-flex justify-content-center align-items-center text-left"
		:class="[allProducts ? '' : '']"
	>
		<div :class="[
			smallClass ? 'col-6' : '',
			allProducts ? 'col-2' : '',
			!smallClass && !allProducts ? 'col-2' : ''
		]">
			<p :class="[smallClass ? 'font-weight-bold' : '']">
				{{item.nev}}
			</p>
		</div>
		<div :class="[
			smallClass ? 'col-6' : '',
			allProducts ? 'col-4' : '',
			!smallClass && !allProducts ? 'col-4' : ''
		]">
			<!--<div class="mui-textfield" v-if="lastorder">
				<textarea :placeholder="lastmegj" disabled></textarea>
		    	<label>Utolsó megj.</label>
			</div>-->
			<div v-if="lastorder">
				<p class="">
					<label>
						Utolsó megjegyzés:
						<button
							v-if="copyComment == true"
		    				class="btn btn-sm btn-primary"
		    				@click="copyCommentMethod"
				    	>
				    		Másolás
				    	</button>
					</label><br>
					{{ lastmegj }}
				</p>
			</div>
			<div class="mui-textfield" v-if="!allProducts">
		    	<input type="text" v-model="rendmegj">
		    	<label>Rendelési megj.
		    	</label>
		  	</div>
		  	<div class="mui-textfield" v-else>
				<textarea v-model="rendmegj"></textarea>
				<label>Rendelési megj.</label>
			</div>
		</div>
		<div
			:class="[
				smallClass ? 'col-6' : '',
				allProducts ? 'col-3' : '',
				!smallClass && !allProducts ? 'col-2' : ''
			]"
			class="align-items-center"
		>
			<div class="input-group">
			  	<input type="number" class="form-control" v-model="ujar">
			  	<div class="input-group-append">
			    	<span class="input-group-text">Ft / db</span>
			  	</div>
			</div>
		</div>
		<div :class="[
			smallClass ? 'col-6' : '',
			allProducts ? 'col-3' : '',
			!smallClass && !allProducts ? 'col-2' : ''
		]">
			<div class="row d-flex justify-content-center">
				<div class="input-group">
					<div class="input-group-prepend">
						<button
							class="btn btn-outline-primary"
							@click.prevent="change_db(-1)"
							:disabled="item.db <= 1"
						>
							<i class="fa fa-minus"></i>
						</button>
					</div>
						<input type="number" class="form-control" v-model="actdb">
					<div class="input-group-append">
						<button
							class="btn btn-outline-primary"
							@click.prevent="change_db(1)"
						>
							<i class="fa fa-plus"></i>
						</button>
					</div>
					<div class="input-group-append">
						<button
							class="btn btn-primary"
							@click.prevent="addCart(item)"
							:disabled="item.db < 1"
						>
							<i class="fa fa-cart-plus" v-if="allProducts"></i>
							<span v-else>
								Kosárba
							</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12">
			<hr>
		</div>
	</div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
	name: 'order_item',

	data(){
		return {
			actdb: 0,
			ujar: 0,
			rendmegj: '',
			szalmegj: ''
		}
	},

	props: ['tszam','nev','ar','db','smallClass','lastorder','lastmegj','allProducts','copyComment'],

	mounted(){
		this.actdb = this.db
		this.ujar = ~~this.ar
	},

	methods: {
		...mapActions(['addToCart']),

		change_db(num){
			this.actdb = ~~this.actdb + ~~num
		},

		addCart(item){
			this.addToCart(item)
			toastr.info(`Hozzáadva a kosárhoz`)
		},

		copyCommentMethod() {
			this.rendmegj = this.lastmegj
		}
	},

	computed: {
		item(){
			return {
				'tszam': this.tszam,
				'nev': this.nev,
				'ar': ~~this.ujar,
				'db': ~~this.actdb,
				'rendmegj': this.rendmegj,
				'szalmegj': this.szalmegj
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/order_item.vue